import { render, staticRenderFns } from "./EmailInput.vue?vue&type=template&id=08fef99a&scoped=true"
import script from "./EmailInput.vue?vue&type=script&lang=ts"
export * from "./EmailInput.vue?vue&type=script&lang=ts"
import style0 from "./EmailInput.vue?vue&type=style&index=0&id=08fef99a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fef99a",
  null
  
)

export default component.exports